import { render, staticRenderFns } from "./DropdownDirection.vue?vue&type=template&id=423c6ab1&"
import script from "./DropdownDirection.vue?vue&type=script&lang=js&"
export * from "./DropdownDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports